module.exports = __webpack_public_path__ + "img/sprinkle-18.d43cce61.webp";